module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.18756b1.eot";